import { Action } from '@ngrx/store';
import { MeteringPointGroup } from '@model';

export enum MeteringPointGroupActionTypes {
  LoadMeteringPointGroupData = '[MeteringPointGroup] Load',
  LoadMeteringPointGroupDataSuccess = '[MeteringPointGroup] Load success',
  LoadMeteringPointGroupDataFail = '[MeteringPointGroup] Load fail',

  AddMeteringPointGroup = '[MeteringPointGroup] Add',
  AddMeteringPointGroupSuccess = '[MeteringPointGroup] Add Success',
  AddMeteringPointGroupFail = '[MeteringPointGroup] Add Fail',

  UpdateMeteringPointGroup = '[MeteringPointGroup] Update',
  UpdateMeteringPointGroupSuccess = '[MeteringPointGroup] Update Success',
  UpdateMeteringPointGroupFail = '[MeteringPointGroup] Update Fail',

  RemoveMeteringPointGroup = '[MeteringPointGroup] Remove',
  RemoveMeteringPointGroupSuccess = '[MeteringPointGroup] Remove Success',
  RemoveMeteringPointGroupFail = '[MeteringPointGroup] Remove Fail',

  BulkUpdateMeteringPointGroups = '[MeteringPointGroup] Bulk Update',
  BulkUpdateMeteringPointGroupsSuccess = '[MeteringPointGroup] Bulk Update Success',
  BulkUpdateMeteringPointGroupsFail = '[MeteringPointGroup] Bulk Update Fail',
  ClearMeteringPointGroups = '[MeteringPointGroup] Clear groups'
}

export class LoadMeteringPointGroups implements Action {
  readonly type = MeteringPointGroupActionTypes.LoadMeteringPointGroupData;
  constructor() {}
}

export class LoadMeteringPointsGroupsSuccess implements Action {
  readonly type = MeteringPointGroupActionTypes.LoadMeteringPointGroupDataSuccess;
  constructor(public payload: MeteringPointGroup[]) {}
}

export class LoadMeteringPointsGroupsFail implements Action {
  readonly type = MeteringPointGroupActionTypes.LoadMeteringPointGroupDataFail;
  constructor(public payload: any) {}
}

export class AddMeteringPointGroup implements Action {
  readonly type = MeteringPointGroupActionTypes.AddMeteringPointGroup;
  constructor(public payload: MeteringPointGroup) {}
}

export class AddMeteringPointGroupSuccess implements Action {
  readonly type = MeteringPointGroupActionTypes.AddMeteringPointGroupSuccess;
  constructor(public payload: MeteringPointGroup) {}
}

export class AddMeteringPointGroupFail implements Action {
  readonly type = MeteringPointGroupActionTypes.AddMeteringPointGroupFail;
  constructor(public payload: any) {}
}

export class UpdateMeteringPointGroup implements Action {
  readonly type = MeteringPointGroupActionTypes.UpdateMeteringPointGroup;
  constructor(public payload: MeteringPointGroup) {}
}

export class UpdateMeteringPointGroupSuccess implements Action {
  readonly type = MeteringPointGroupActionTypes.UpdateMeteringPointGroupSuccess;
  constructor(public payload: MeteringPointGroup) {}
}

export class UpdateMeteringPointGroupFail implements Action {
  readonly type = MeteringPointGroupActionTypes.UpdateMeteringPointGroupFail;
  constructor(public payload: any) {}
}

export class RemoveMeteringPointGroup implements Action {
  readonly type = MeteringPointGroupActionTypes.RemoveMeteringPointGroup;
  constructor(public payload: MeteringPointGroup) {}
}

export class RemoveMeteringPointGroupSuccess implements Action {
  readonly type = MeteringPointGroupActionTypes.RemoveMeteringPointGroupSuccess;
  constructor(public payload: MeteringPointGroup) {}
}

export class RemoveMeteringPointGroupFail implements Action {
  readonly type = MeteringPointGroupActionTypes.RemoveMeteringPointGroupFail;
  constructor(public payload: any) {}
}

export class BulkUpdateMeteringPointGroups implements Action {
  readonly type = MeteringPointGroupActionTypes.BulkUpdateMeteringPointGroups;
  constructor(public payload: MeteringPointGroup[]) {}
}

export class BulkUpdateMeteringPointGroupsSuccess implements Action {
  readonly type = MeteringPointGroupActionTypes.BulkUpdateMeteringPointGroupsSuccess;
  constructor(public payload: MeteringPointGroup[]) {}
}

export class BulkUpdateMeteringPointGroupsFail implements Action {
  readonly type = MeteringPointGroupActionTypes.BulkUpdateMeteringPointGroupsFail;
  constructor(public payload: any) {}
}
export class ClearMeteringPointGroups implements Action {
  readonly type = MeteringPointGroupActionTypes.ClearMeteringPointGroups;
  constructor() {}
}

export type MeteringPointGroupActions =
  | LoadMeteringPointGroups
  | LoadMeteringPointsGroupsSuccess
  | LoadMeteringPointsGroupsFail
  | AddMeteringPointGroup
  | AddMeteringPointGroupSuccess
  | AddMeteringPointGroupFail
  | UpdateMeteringPointGroup
  | UpdateMeteringPointGroupSuccess
  | UpdateMeteringPointGroupFail
  | BulkUpdateMeteringPointGroups
  | BulkUpdateMeteringPointGroupsSuccess
  | BulkUpdateMeteringPointGroupsFail
  | RemoveMeteringPointGroup
  | RemoveMeteringPointGroupSuccess
  | RemoveMeteringPointGroupFail
  | ClearMeteringPointGroups;
